(() => {
  const carousels = document.querySelectorAll('[data-ax-carousel]');

  carousels.forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-ax-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-ax-dot]'));

    if (slides.length < 2) return;

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const setSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.toggleAttribute('inert', !isActive);
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    carousel.querySelector('[data-ax-prev]')?.addEventListener('click', () => {
      setSlide(activeIndex - 1);
    });

    carousel.querySelector('[data-ax-next]')?.addEventListener('click', () => {
      setSlide(activeIndex + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => setSlide(index));
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setSlide(activeIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        setSlide(activeIndex + 1);
      }
    });

    let touchStartX = null;

    carousel.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      (event) => {
        if (touchStartX === null) return;

        const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = touchEndX - touchStartX;

        if (Math.abs(distance) > 40) {
          setSlide(activeIndex + (distance < 0 ? 1 : -1));
        }

        touchStartX = null;
      },
      { passive: true }
    );

    setSlide(activeIndex);
  });
})();
